import React, {FC} from 'react';
import {FilterGroup} from './FilterGroup';
import {GenericFilterItemGroup} from './types';
import {useFilterItemGroups} from './useFilterItemGroups';

export interface GenericFilteredItemsProps {
  search: string;
  activeIds: Array<string>;
  itemGroups: Array<GenericFilterItemGroup>;
  onItemClick?: (itemId: string, itemSlug?: string) => void;
  className?: string;
  dataTestId?: string;
  enableFilterFlyout?: boolean;
}

export const GenericFilteredItems: FC<GenericFilteredItemsProps> = ({
  search,
  activeIds,
  itemGroups,
  onItemClick,
  className,
  dataTestId = 'genericFilteredItems',
  enableFilterFlyout = true,
}) => {
  const filteredBrandGroups = useFilterItemGroups({
    itemGroups,
    search,
  });

  return (
    <div className={className} data-testid={`${dataTestId}-search`}>
      {filteredBrandGroups.map((dataGroup, i) => {
        return (
          <FilterGroup
            isFirstGroup={i === 0}
            activeIds={activeIds}
            onItemClick={onItemClick}
            dataGroup={dataGroup}
            dataTestId={`${dataTestId}${dataGroup.groupLabel}`}
            key={`filter-group-${dataGroup.groupLabel}`}
            enableFilterFlyout={enableFilterFlyout}
          />
        );
      })}
    </div>
  );
};
